import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Redirect, Route, Switch } from 'react-router-dom';
import { actions } from '../../redux/modules/app';
import { Login, LoginModal } from './Login';
import { ResetPassword } from './ResetPassword';
import { CreateAccount } from './CreateAccount';

export const Authentication = compose(
  connect(
    state => ({
      authenticated: state.app.authenticated,
      authRedirect: state.app.authRedirect,
    }),
    {
      setAuthenticated: actions.setAuthenticated,
    },
  ),
)(
  ({
    loggedIn,
    loginProps,
    timedOut,
    authenticated,
    setAuthenticated,
    authRedirect,
    children,
  }) => {
    useEffect(
      () => {
        setAuthenticated(loggedIn);
      },
      [loggedIn, setAuthenticated, timedOut],
    );

    return (
      <>
        {timedOut && <LoginModal loginProps={loginProps} />}
        <Switch>
          {authenticated ? (
            <Redirect
              path={['/login', '/reset-password', '/create-account', '/logout']}
              to={authRedirect || '/'}
            />
          ) : (
            [
              <Route path="/login" key="login">
                <Login loginProps={loginProps} />
              </Route>,
              <Route
                path="/reset-password/:token?"
                key="reset"
                component={ResetPassword}
              />,
              <Route
                path="/create-account"
                key="create"
                component={CreateAccount}
              />,
              <Route path="/logout" key="logout">
                <Login
                  loginProps={loginProps}
                  isLogout={true}
                  title="Logged Out of ERMS"
                  subtitle={
                    <>
                      <a href="https://www.eauth.usda.gov/eauth/b/usda/logoff">
                        Log Out of eAuth
                      </a>{' '}
                      (Note: This will log you out of all eAuth protected
                      applications.)
                    </>
                  }
                />
              </Route>,
            ]
          )}
          <Route path="/">{children}</Route>
        </Switch>
      </>
    );
  },
);
